import { Stack } from '@mui/material';
import React from 'react';

import AdType from './fields/AdType';
import Associated from './fields/Associated';
import Category from './fields/Category';
import CustomSchedule from './fields/CustomSchedule';
import AdResponse from './fields/icaNativeAd/AdResponse';
import PlacementType from './fields/icaNativeAd/PlacementType';
import Name from './fields/Name';
import Properties from './fields/Properties';
import Size from './fields/Size';
import ThirdPartyTagIds from './fields/ThirdPartyTagIds';
import Variables from './fields/Variables';

interface NativeProps {
  adGroupId?: number;
}

export default function Native({ adGroupId }: NativeProps) {
  return (
    <Stack spacing={2}>
      <Name />
      {Boolean(adGroupId) && <Associated />}
      <Properties />
      <Category />
      <Stack direction="row" spacing={2}>
        <Size readOnly defaultValue="ICA Native" />
        <AdType />
      </Stack>
      <PlacementType />
      <AdResponse />
      <ThirdPartyTagIds />
      <CustomSchedule />
      <Variables />
    </Stack>
  );
}
